const ModalBase = ({close}) => {
    return ( <div className="modal-base" onClick={close}>
    </div> )
}
 
export default ModalBase